import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "./store/hooks";

const ProtectedRouting = () => {
  const isAuthenticated = useAppSelector((s) => s.User.IsAuthenticated);
  return isAuthenticated ? <Outlet /> : (<Navigate to="/account/login"/>);
};
export default ProtectedRouting;
